import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { usePrivateImage } from "@/hooks/usePrivateImage";
import { useReceiptActions } from "@/hooks/useReceiptActions";
import ReceiptPrintable from "@/components/ReceiptPrintable";
import { Printer, Download, Loader2 } from "lucide-react";

const NODE_ID = "receipt-printable";

function ReceiptBody({ a, open, onOpenChange }) {
  const imgSrc = usePrivateImage(a.prescription_path, open);
  const { downloading, print, download } = useReceiptActions(a, NODE_ID);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="receipt-modal-dialog" className="max-w-3xl max-h-[92vh] overflow-y-auto p-0">
        <DialogTitle className="sr-only">Receipt {a.receipt_no}</DialogTitle>
        <div className="no-print flex items-center justify-between gap-3 px-6 py-4 border-b bg-slate-50 sticky top-0 z-10">
          <h3 className="font-head font-semibold text-lg">Consultation Receipt</h3>
          <div className="flex gap-2">
            <Button data-testid="print-receipt-button" variant="outline" onClick={print}><Printer className="h-4 w-4 mr-2" /> Print</Button>
            <Button data-testid="download-pdf-button" onClick={download} disabled={downloading} className="bg-teal-600 hover:bg-teal-700 text-white">
              {downloading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Download className="h-4 w-4 mr-2" />} Download PDF
            </Button>
          </div>
        </div>
        <ReceiptPrintable a={a} imgSrc={imgSrc} nodeId={NODE_ID} />
      </DialogContent>
    </Dialog>
  );
}

export default function ReceiptModal({ open, onOpenChange, appointment }) {
  if (!appointment) return null;
  return <ReceiptBody a={appointment} open={open} onOpenChange={onOpenChange} />;
}
